import clsx from 'clsx'
import type { ReactNode } from 'react'

interface Props {
  label: string
  value: ReactNode
  /**
   * Size + color classes for the value text. Defaults to `text-[28px] text-charcoal-75`.
   * Replace fully when a different size or color is needed (e.g. `text-[24px] text-charcoal-75`
   * for the date cards, `text-[28px] text-orange` for the Missed Appts count).
   */
  valueClassName?: string
}

const DEFAULT_VALUE_CLASS = 'text-[28px] text-charcoal-75'

export function StatCell({ label, value, valueClassName }: Props) {
  return (
    <div className="flex min-w-[170px] flex-col gap-2">
      <p className="text-sm font-semibold leading-6 text-charcoal-75">{label}</p>
      <p
        className={clsx(
          'whitespace-nowrap font-bold leading-[1.5]',
          valueClassName ?? DEFAULT_VALUE_CLASS
        )}
      >
        {value}
      </p>
    </div>
  )
}
